import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import userServiceApi from "../../api/userServiceApi";
import { getRequest } from "../../api/http";
import { Avatar, Divider, Popover } from "antd";
import "./index.scss";
import DefaultLogo from "../../assets/images/defaultLogo.svg";
import Leftarrow from "../../assets/images/LeftArrow.svg";
import profileIcon from "../../assets/images/profile-icon.svg";
import helpIcon from "../../assets/images/help-icon.svg";
import feedbackIcon from "../../assets/images/feedback-icon.svg";
import logoutIcon from "../../assets/images/logout-icon.svg";
import changePwdIcon from "../../assets/images/change-pwd-icon.svg";
import detailsIcon from "../../assets/images/details-icon.svg";
import { useStore } from "../../store";
import {
  fetchAccountOnboardingComplete,
  isStripeOnboardingPending,
} from "../../utils/stripeOnboarding";

function MicroSites() {
  const { orgImageUrl } = useStore();
  const navigate = useNavigate();
  const [isShowProfile, setIsShowProfile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [partnerData, setPartnerData] = useState({});

  let orgImg = sessionStorage.getItem("OrgImage");
  const [onboardingPending, setOnboardingPending] = useState(() =>
    isStripeOnboardingPending()
  );

  const showProfile = () => {
    setIsShowProfile(!isShowProfile);
  };

  const handleNavItemClick = (action) => {
    if (onboardingPending) return;
    setIsShowProfile(false);
    action();
  };

  const LogoutHandler = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  };

  const getPartnerDetailsData = async () => {
    try {
      setLoading(true);
      const response = await getRequest(userServiceApi.partnerDetails());
      if (response && response.data) {
        setPartnerData(response.data);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.error);
    }
  };

  const getFirstLetters = (name) => {
    // Split the name into words
    const words = name.split(' ');

    // Extract the first letter from each word
    const firstLetters = words.map(word => word.charAt(0));

    // Join the first letters into a string
    const result = firstLetters.join('');

    const finalResult = result.toUpperCase();

    return finalResult;
  }

  useEffect(() => {
    getPartnerDetailsData();
    orgImg = sessionStorage.getItem("OrgImage");
  }, []);

  useEffect(() => {
    const syncOnboardingPending = async () => {
      const connectedAccountId = sessionStorage.getItem("connectedAccountId");
      if (!connectedAccountId) {
        setOnboardingPending(isStripeOnboardingPending());
        return;
      }
      const onboardingComplete = await fetchAccountOnboardingComplete(
        connectedAccountId
      );
      setOnboardingPending(!onboardingComplete);
    };

    syncOnboardingPending();
  }, []);
  return (
    <div className="headerBannerRow">
      <div className="headerBannerCol">
        <div className="header-logo">
          <img
            src={orgImageUrl ? orgImageUrl : orgImg ? orgImg : `${process.env.REACT_APP_API_BASE_URL}/${DefaultLogo}`}
            className={onboardingPending ? "header-logo-disabled" : ""}
            onClick={() => {
              if (onboardingPending) return;
              sessionStorage.setItem("page", "home");
              navigate("/partner-org", { screen: "Home" });
              sessionStorage.setItem("activeKey", 1);
            }}
            alt=""
          />
        </div>
        <div className="profile-container">
          <div className="profile-text">
            <label className="org-name">
              {sessionStorage.getItem("OrgName")}
            </label>
            <label className="admin-label">Partner Admin</label>
          </div>
          <Popover
            content={
              <div className="popover-content">
                <div className="dropdown-details">

                  <div
                    className={`popover-single-content${onboardingPending ? " menu-item-disabled" : ""}`}
                    onClick={() => handleNavItemClick(() => navigate("/partner-details"))}
                    title={onboardingPending ? "Complete onboarding to access" : ""}
                  >
                    <img src={profileIcon} alt="" />
                    <h3>Profile</h3>
                  </div>
                  <Divider />

                  <div
                    className={`popover-single-content${onboardingPending ? " menu-item-disabled" : ""}`}
                    onClick={() => handleNavItemClick(() => navigate("/feedback"))}
                    title={onboardingPending ? "Complete onboarding to access" : ""}
                  >
                    <img src={feedbackIcon} alt="" />
                    <h3>Support & Feedback</h3>
                  </div>
                  <Divider />
                  {/* <div
                    className={`popover-single-content${onboardingPending ? " menu-item-disabled" : ""}`}
                    onClick={() => handleNavItemClick(() => navigate("/payment-history"))}
                    title={onboardingPending ? "Complete onboarding to access" : ""}
                  >
                    <img src={detailsIcon} alt="" />
                    <h3>Payment History</h3>
                  </div> */}
                  {/* <Divider /> */}
                  <div
                    className={`popover-single-content${onboardingPending ? " menu-item-disabled" : ""}`}
                    onClick={() => handleNavItemClick(() => navigate("/change-password"))}
                    title={onboardingPending ? "Complete onboarding to access" : ""}
                  >
                    <img src={changePwdIcon} alt="" />
                    <h3>Change Password</h3>
                  </div>
                  <Divider />
                  <div
                    className="popover-single-content"
                    onClick={() => {
                      setIsShowProfile(false);
                      LogoutHandler();
                    }}
                  >
                    <img src={logoutIcon} alt="" />
                    <h3>Logout</h3>
                  </div>
                </div>
              </div>
            }
            trigger="click"
            open={isShowProfile}
            onOpenChange={showProfile}
            placement="bottomRight"
          >
            <Avatar
              style={{ cursor: "pointer" }}
              onClick={() => showProfile()}
              size={50}
            >

              {partnerData?.name ? getFirstLetters(partnerData?.name) : ""}
            </Avatar>

          </Popover>
        </div >

      </div >
    </div >
  );
}
export default MicroSites;
